import * as importCheckoutActions from '@appActions/pendings/checkout/checkout.actions';
import * as importCheckoutListActions from '@appActions/pendings/checkout/checkout-list/checkout-list.actions';
import * as importCheckoutDetailsActions from '@appActions/pendings/checkout/checkout-details/checkout-details.actions';

export const checkoutActions = importCheckoutActions;
export const checkoutListActions = importCheckoutListActions;
export const checkoutDetailsActions = importCheckoutDetailsActions;
